import * as dateFns from 'date-fns';
import fp from 'lodash/fp';
import React from 'react';
import { Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { dateFormats, routes } from '../../../../../constants';
import { GeneralTable } from '../../../../components';

const columns = [
  {
    key: 'date',
    name: 'Date'
  },
  {
    key: 'cpdPeriod',
    name: 'CPD Period'
  },
  {
    key: 'options',
    name: 'Options'
  }
]

export const UserSnapshotTable = ({ user, snapshots }) => {
  const rows = fp.map(
    ({ dateCreated, cpdCategorys, goals, snapshotId, cpdDay, cpdMonth, fromDate, toDate }) => {
      return {
        date: {
          value: dateFns.format(new Date(dateCreated), dateFormats.ShortDate)
        },
        cpdPeriod: {
          value: `${dateFns.format(new Date(fromDate), dateFormats.ShortDate)} - ${dateFns.format(new Date(toDate), dateFormats.ShortDate)}`
        },
        options: {
          value: <div>
            <LinkContainer to={routes.adminPortal.userSnapshotReport(user.id, snapshotId)}>
              <Button bsStyle='plain'>
                View Report
              </Button>
            </LinkContainer>
          </div>
        }
      }
    }
  )(snapshots)

  return <div>
    {
      rows.length > 0 && <GeneralTable rows={rows} columns={columns} />
    }
  </div>
}


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/user-portal/partial/user-snapshot-table.js